export const getValue = (array, newValue) => {
  let value = array.filter(
    (element) =>
      element.title.replace(/\t/g, " ") === newValue ||
      element.nameEN === newValue ||
      element.nameES === newValue
  )[0].title;
  return value;
};
